module.exports = __webpack_public_path__ + "76842291232d311356ebaeecfa76bb9f.png";